// extracted by mini-css-extract-plugin
export default {"menuText":"DropdownMenu_menuText__iNgG4","menuItems":"DropdownMenu_menuItems__BxI4J","menuIcon":"DropdownMenu_menuIcon__r0zCo"};